/* eslint-disable */
jQuery('.show-thumb  > a + a').each(function () {
  jQuery(this).text(`${jQuery(this)
    .text()
    .substr(0, 58)}...`);
});
